import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { baseURL } from './baseurl';

@Injectable({
  providedIn: 'root'
})
export class PlantpredictService {
  constructor(private authService: AuthService, private http: HttpClient) { }

  predictplant(text):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const plantdata = JSON.stringify(text);
    return this.http.post<any>(baseURL+'api/recommend/',text,{headers})
    .pipe(map(res => {
     // console.log(res);
      return res;
  }))
  }
}
